import dbConnection from '../dbConnection'
const meditations = {
  getMeditations: function(page) {
    return dbConnection.get('members/meditations/all/' + page)
  },
  getMeditation: function(meditationId){
    return dbConnection.get('members/meditations/single/' + meditationId)
  }
}
export default meditations